import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "./lib/helmet";
import { I18nextProvider } from "react-i18next";
import App from "./App";
import { createI18n, getLangInfo } from "./i18n";
import "./index.css";

const { lang } = getLangInfo(window.location.pathname);
const rootElement = document.getElementById("root");
const i18n = createI18n(lang);

if (rootElement) {
  createRoot(rootElement).render(
    <HelmetProvider>
      <I18nextProvider i18n={i18n}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </I18nextProvider>
    </HelmetProvider>,
  );
}
